import React from "react";

const NotFound = () => {
  return (
    <div>
      <h2>404 - Not Found</h2>
      <p>Sorry, the page you're looking for does not exist.</p>
    </div>
  );
};

export default NotFound;